export interface ITrame {
  id: string
  createdAt: string
  updatedAt: string
  name: string
  modules: IModule[]
  prosperencesStyled?: boolean
  colored?: boolean
  versionAdhoc?: number
}

interface ModuleType {
  id: string
  name: string
}

export const moduleNames: ModuleType[] = [
  {
    id: 'pageGarde',
    name: 'Page de garde',
  },
  {
    id: 'methodologie',
    name: 'Méthodologie',
  },
  {
    id: 'surfacique',
    name: 'Surfacique',
  },
  {
    id: 'ponctuel',
    name: 'Ponctuel',
  },
]

type TModuleType = typeof moduleNames[number]['name']

interface IDataPageGarde {
  idLogoOrga: String
  insererLogoProsperences: boolean
  insererCarte: boolean
  carteParam: string
  titre: string
  texte: string
  zone: boolean
  description: string
  cloudinaryData?: {
    assetId: string
    path: string
    secureUrl: string
  }
  cloudinaryDataCarteStandard?: {
    assetId: string
    path: string
    secureUrl: string
  }
}

interface IDataMethodologie {
  zoneTexte: string 
}

interface IDataSurfacique {
  titre: string
  zoneTexte: string
  potentiel: string
  insererTableau: string
  insererCarte: boolean 
  carteParam: string
  tableauColonnesProduits: string[]
  tableauColonnesMetrics: Array<string>
}

interface IDataPonctuel {
  titre: string
  zoneTexte: string 
  insererCarte: boolean
  carteParam: string
  typeBloc: string
  colBloc? : Array<string>
}



export interface IModule {
  id: string
  typeModule?: TModuleType
  dataPageGarde?: IDataPageGarde
  dataMethodologie?: IDataMethodologie
  dataSurfacique?: IDataSurfacique
  dataPonctuel?: IDataPonctuel
}
